import ProjectClause from './ProjectClause';
export default ProjectClause;